import { Row } from "@/components";
import { HexagonIconBadge } from "@/components/leaderboard/HexagonIconBadge";
import { MetricLeadersHoverCard } from "@/components/leaderboard/MetricLeadersHoverCard";
import { leaderboardMetrics } from "@/lib/leaderboardMetrics";

import type { LeaderboardUser } from "@/types";

// A hex badge for each metric the user currently leads, laid out on one line.
// Hovering a badge reveals that category's top 3. The crown (last month's
// revenue winner) lives on the avatar, not here.
export const LeaderboardStafferBadges = ({
  user,
  users,
}: {
  user: LeaderboardUser;
  users: LeaderboardUser[];
}) => (
  <Row className="shrink-0 flex-nowrap items-center gap-0.5">
    {leaderboardMetrics.BADGE_METRICS.map((metric) =>
      leaderboardMetrics.isLeader(users, user.userId, metric.key) ? (
        <MetricLeadersHoverCard
          key={metric.key}
          title={metric.label}
          icon={metric.icon}
          gradient={metric.gradient}
          leaders={leaderboardMetrics.topN(users, metric.key, 3)}
          valueOf={(u) => u[metric.key] as number}
          format={metric.format}
        >
          <Row className="cursor-default">
            <HexagonIconBadge
              icon={metric.icon}
              gradient={metric.gradient}
              size="table"
            />
          </Row>
        </MetricLeadersHoverCard>
      ) : null,
    )}
  </Row>
);
